import {LANGUAGE_CODES} from '@chekin/core';
import {LanguageItem} from './types';
import bulgariaFlag from 'assets/icons/language-flags/bulgaria.svg';
import cataloniaFlag from 'assets/icons/language-flags/catalonia.svg';
import croatiaFlag from 'assets/icons/language-flags/croatia.svg';
import czechFlag from 'assets/icons/language-flags/czech.svg';
import estoniaFlag from 'assets/icons/language-flags/estonia.svg';
import franceFlag from 'assets/icons/language-flags/france.svg';
import germanyFlag from 'assets/icons/language-flags/germany.svg';
import greeceFlag from 'assets/icons/language-flags/greece.svg';
import hungaryFlag from 'assets/icons/language-flags/hungary.svg';
import italyFlag from 'assets/icons/language-flags/italy.svg';
import koreaFlag from 'assets/icons/language-flags/korea.svg';
import netherlandsFlag from 'assets/icons/language-flags/netherlands.svg';
import polandFlag from 'assets/icons/language-flags/poland.svg';
import portugalFlag from 'assets/icons/language-flags/portugal.svg';
import romaniaFlag from 'assets/icons/language-flags/romania.svg';
import russiaFlag from 'assets/icons/language-flags/russia.svg';
import spainFlag from 'assets/icons/language-flags/spain.svg';
import unitedKingdomFlag from 'assets/icons/language-flags/uk.svg';
import ukraineFlag from 'assets/icons/language-flags/ukraine.svg';

const languageFlags = {
  [LANGUAGE_CODES.bg]: bulgariaFlag,
  [LANGUAGE_CODES.ca]: cataloniaFlag,
  [LANGUAGE_CODES.hr]: croatiaFlag,
  [LANGUAGE_CODES.cs]: czechFlag,
  [LANGUAGE_CODES.et]: estoniaFlag,
  [LANGUAGE_CODES.fr]: franceFlag,
  [LANGUAGE_CODES.de]: germanyFlag,
  [LANGUAGE_CODES.el]: greeceFlag,
  [LANGUAGE_CODES.hu]: hungaryFlag,
  [LANGUAGE_CODES.it]: italyFlag,
  [LANGUAGE_CODES.ko]: koreaFlag,
  [LANGUAGE_CODES.nl]: netherlandsFlag,
  [LANGUAGE_CODES.pl]: polandFlag,
  [LANGUAGE_CODES.pt]: portugalFlag,
  [LANGUAGE_CODES.ro]: romaniaFlag,
  [LANGUAGE_CODES.ru]: russiaFlag,
  [LANGUAGE_CODES.es]: spainFlag,
  [LANGUAGE_CODES.en]: unitedKingdomFlag,
  [LANGUAGE_CODES.uk]: ukraineFlag,
};

export const appLocaleNamespaces = [
  'translation',
  'identity-verification',
  'check-out',
  'vela',
];

export const languageOptions: LanguageItem[] = [
  {
    value: LANGUAGE_CODES.en,
    label: 'English',
    country: 'United States',
    flag: languageFlags[LANGUAGE_CODES.en],
  },
  {
    value: LANGUAGE_CODES.es,
    label: 'Español',
    country: 'Spain',
    flag: languageFlags[LANGUAGE_CODES.es],
  },
  {
    value: LANGUAGE_CODES.it,
    label: 'Italiano',
    country: 'Italy',
    flag: languageFlags[LANGUAGE_CODES.it],
  },
  {
    value: LANGUAGE_CODES.de,
    label: 'Deutsch',
    country: 'Germany',
    flag: languageFlags[LANGUAGE_CODES.de],
  },
  {
    value: LANGUAGE_CODES.fr,
    label: 'Français',
    country: 'France',
    flag: languageFlags[LANGUAGE_CODES.fr],
  },
  {
    value: LANGUAGE_CODES.nl,
    label: 'Nederlands',
    country: 'Nederland',
    flag: languageFlags[LANGUAGE_CODES.nl],
  },
  {
    value: LANGUAGE_CODES.ko,
    label: '한국어',
    country: '대한민국',
    flag: languageFlags[LANGUAGE_CODES.ko],
  },
  {
    value: LANGUAGE_CODES.hu,
    label: 'Magyar',
    country: 'Magyar',
    flag: languageFlags[LANGUAGE_CODES.hu],
  },
  {
    value: LANGUAGE_CODES.ru,
    label: 'Русский',
    country: 'Russia',
    flag: languageFlags[LANGUAGE_CODES.ru],
  },
  {
    value: LANGUAGE_CODES.cs,
    label: 'Čeština',
    country: 'Čeština',
    flag: languageFlags[LANGUAGE_CODES.cs],
  },
  {
    value: LANGUAGE_CODES.bg,
    label: 'Български',
    country: 'Български',
    flag: languageFlags[LANGUAGE_CODES.bg],
  },
  {
    value: LANGUAGE_CODES.pt,
    label: 'Português',
    country: 'Português',
    flag: languageFlags[LANGUAGE_CODES.pt],
  },
  {
    value: LANGUAGE_CODES.ro,
    label: 'Română',
    country: 'Română',
    flag: languageFlags[LANGUAGE_CODES.ro],
  },
  {
    value: LANGUAGE_CODES.et,
    label: 'Eestlane',
    country: 'Eestlane',
    flag: languageFlags[LANGUAGE_CODES.et],
  },
  {
    value: LANGUAGE_CODES.ca,
    label: 'Català',
    country: 'Catalunya',
    flag: languageFlags[LANGUAGE_CODES.ca],
  },
  {
    value: LANGUAGE_CODES.pl,
    label: 'Polski',
    country: 'Polska',
    flag: languageFlags[LANGUAGE_CODES.pl],
  },
  {
    value: LANGUAGE_CODES.el,
    label: 'Ελληνικά',
    country: 'Greece',
    flag: languageFlags[LANGUAGE_CODES.el],
  },
  {
    value: LANGUAGE_CODES.uk,
    label: 'Українська',
    country: 'Ukraine',
    flag: languageFlags[LANGUAGE_CODES.uk],
  },
  {
    value: LANGUAGE_CODES.hr,
    label: 'Hrvatski',
    country: 'Hrvatska',
    flag: languageFlags[LANGUAGE_CODES.hr],
  },
];

export const normalizeLanguageCode = (code?: string | null) =>
  (code ?? '').slice(0, 2).toLowerCase();

export const getLanguageOption = (code?: string | null) =>
  languageOptions.find(option => option.value === normalizeLanguageCode(code));

export const getLanguageLabel = (code?: string | null) => getLanguageOption(code)?.label;
